import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

import Button from "../../components/common/Button/Button";
import FormInput from "../../components/common/FormInput/FormInput";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";
import { addCustomPage } from "../../api/service/custompage.service";

const AddCustomPage = () => {
  const navigate = useNavigate();
  const { menuId, id } = useParams();


  const finalMenuId = menuId || id;

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  // console.log("Menu ID:", finalMenuId);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title) {
      showToast.error("Please enter title");
      return;
    }

    if (!finalMenuId) {
      showToast.error("Menu ID is missing");
      return;
    }

    try {
      setLoading(true);

      const submitData = {
        menu_id: finalMenuId,
        title,
        description,
      };

      const response = await addCustomPage(submitData);

      if (response.success) {
        showToast.success(
          response.message || "Custom page created successfully!"
        );
        navigate("/menu");
      } else {
        showToast.error(response.message || "Creation failed");
      }
    } catch (error) {
      console.error("Create Error:", error);
      showToast.error("Failed to create custom page");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="management-tile mb-0">Add Custom Details</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="mb-3">
            <label className="form-label">Title</label>
            <FormInput
              value={title}
              placeholder="Enter title"
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">Description</label>
            <FormInput
              type="textarea"
              value={description}
              placeholder="Page description"
              onChange={(e) => setDescription(e.target.value)}
            />
          </Col>

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create Page"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default AddCustomPage;
